// extracted by mini-css-extract-plugin
export var closeButton = "_ik-2";
export var closeButtonIcon = "_ik-3";
export var lightboxContent = "_ik-1";
export var lightboxOverlay = "_ik-0";